import {useState} from "react";
import {KTSVG} from "../../../../../../_metronic/helpers";
import {nl2br} from "../../../../../helpers/Formatter";
import { GeoCommentForm } from "./GeoCommentForm";

export interface IGeoCommentProps {
    msisdn?: string | undefined
    comment?: string | undefined
}

/**
 * Компонент комментария к местоположению
 */
export function GeoComment({msisdn, comment}: IGeoCommentProps) {
    const [show, setShow] = useState(false)
    const [updatedComment, setUpdatedComment] = useState<string | undefined>(undefined)

    const closeModal = (updatedComment?: string) => {
        setShow(false)
        setUpdatedComment(updatedComment)
    }

    return (
        <div className="card card-xl-stretch">
            <div className="card-header border-0 pt-5 pb-0 px-5">
                <h3 className="card-title fw-bolder text-gray-800">Комментарий
                    <span
                        style={{cursor: "pointer"}}
                        onClick={() => setShow(true)}
                    ><KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon svg-icon-1 me-3 mx-3'/></span>
                </h3>
            </div>
            <div className="card-body px-5 pt-0 pb-0 fs-5">
                <span>{updatedComment ? nl2br(updatedComment) : nl2br(comment)}</span>
            </div>
            <GeoCommentForm msisdn={msisdn} comment={updatedComment !== undefined ? updatedComment : comment} show={show} handleClose={closeModal}/>
        </div>
    )
}
